import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import PhilosophySection from "@/components/landing/PhilosophySection";
import HowItWorks from "@/components/landing/HowItWorks";
import PricingTeaser from "@/components/landing/PricingTeaser";
import ROICalculator from "@/components/landing/ROICalculator";
import NeutralityPromise from "@/components/landing/NeutralityPromise";
import UrgencySection from "@/components/landing/UrgencySection";
import Footer from "@/components/landing/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { useSEO } from "@/lib/seo";
import { SoftwareApplicationJsonLd } from "@/components/JsonLd";

const Index = () => {
  const seo = useSEO(
    "Neutral Booking Coordination Infrastructure",
    "ClearSlot prevents duplicate reservations across booking platforms — without touching your stack.",
    "https://clearslot.io/",
  );
  return (
    <SmoothScroll>
      {seo}
      <SoftwareApplicationJsonLd />
      <div className="min-h-screen bg-background">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-background focus:text-foreground focus:rounded focus:ring-2 focus:ring-ring"
        >
          Skip to main content
        </a>
        <Navbar />
        <main id="main-content">
          <Hero />
          <ROICalculator />
          <Problem />
          <NeutralityPromise />
          <PhilosophySection />
          <HowItWorks />
          <PricingTeaser />
          <UrgencySection />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
};

export default Index;
